import { createSlice } from '@reduxjs/toolkit';
import { AppState } from '../AppStore';
import { getRoles } from './RoleSlice';
import { getApiKeys } from './ApiKeySlice';
import { getApplications } from './ApplicationSlice';
import { getUsers } from './UserSlice';
import { updateTableData } from '../../store/utilities/SliceDataHelper';
import { EDataTableType } from '../../data/Constants';

import type { IAdministrationState } from '../../../types/IComponentTypes';

const initialState: IAdministrationState = {
  users: {
    data: {},
    totalCount: 0,
    currentPage: 0,
    searchKey: '',
    searchData: {},
    recordsPerPage: 0,
  },
  roles: {
    data: {},
    totalCount: 0,
    currentPage: 0,
    searchKey: '',
    searchData: {},
    recordsPerPage: 0,
  },
  apikeys: {
    data: {},
    totalCount: 0,
    currentPage: 0,
    searchKey: '',
    searchData: {},
    recordsPerPage: 0,
  },
  applications: {
    data: {},
    totalCount: 0,
    currentPage: 0,
    searchKey: '',
    searchData: {},
    recordsPerPage: 0,
  },
};

const administrationSlice = createSlice({
  name: 'administration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.fulfilled, (state, action) => {
        if (!('error' in action.payload)) {
          return updateTableData(
            state.users,
            action.payload,
            !!action.payload.searchKey,
            EDataTableType.Users
          );
        }
        return state;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        if (!('error' in action.payload)) {
          return updateTableData(
            state.roles,
            action.payload,
            !!action.payload.searchKey,
            EDataTableType.Roles
          );
        }
        return state;
      })
      .addCase(getApiKeys.fulfilled, (state, action) => {
        if (
          !('error' in action.payload) &&
          'skipUpdate' in action.payload &&
          !action.payload.skipUpdate
        ) {
          return updateTableData(
            state.apikeys,
            action.payload,
            !!action.payload.searchKey,
            EDataTableType.ApiKeys
          );
        }
        return state;
      })
      .addCase(getApplications.fulfilled, (state, action) => {
        if (!('error' in action.payload)) {
          return updateTableData(
            state.applications,
            action.payload,
            !!action.payload.searchKey,
            EDataTableType.Applications
          );
        }
        return state;
      });
  },
});

export const administration = (state: AppState) => state.administration;

export default administrationSlice.reducer;
